import * as PIXI from 'pixi.js';
export default class Scene {
  // The JSON files are loaded by webpack in PixiComponent.js, and can be passed through the constructor.
  // The texture atlas data aka tex.png are placed by webpack as is in the directory /static/media. From there they can be loaded by the Pixi loader given the url below.
  // API Reference - https://developer.egret.com/en/apidoc/index/name/dragonBones.BaseFactory
  // Source - https://github.com/DragonBones/DragonBonesJS/blob/master/DragonBones/src/dragonBones/factory/BaseFactory.ts
  constructor(
    canvas,
    skeleton,
    texJson,
    texPng,
    armatureName,
    animationName,
    dragonbonesName = null
  ) {
    this.skeleton = skeleton;
    this.texJson = texJson;
    this.texPng = texPng;
    this.dragonbonesName = dragonbonesName;
    this.armatureName = armatureName;
    this.animationName = animationName;
    this.app = new PIXI.Application({
      width: canvas.clientWidth,
      height: canvas.clientHeight,
      transparent: true,
    });
    this.resources = [];
    this.resources.push(this.texPng);
    canvas.appendChild(this.app.view);

    PIXI.Loader.shared.reset();
    for (const resource of this.resources) {
      PIXI.Loader.shared.add(resource, resource);
    }
    PIXI.Loader.shared.onComplete.add((loader, resources) => {
      this.pixiResources = resources;
      this.start();
    });
    PIXI.Loader.shared.load();
  }

  start() {
    const factory = window.dragonBones.PixiFactory.factory;
    factory.parseDragonBonesData(this.skeleton);
    factory.parseTextureAtlasData(
      this.texJson,
      this.pixiResources[this.texPng].texture
    );
    const armatureDisplay = factory.buildArmatureDisplay(
      this.armatureName,
      this.dragonbonesName
    );
    armatureDisplay.animation.play(this.animationName);
    armatureDisplay.x = this.app.view.width / 2;
    armatureDisplay.y = this.app.view.height;
    armatureDisplay.scale.x = 1;
    armatureDisplay.scale.y = 1;
    this.app.stage.addChild(armatureDisplay);
  }
}
